// API Configuration
// In production, use relative URLs (proxied through Caddy)
// In development, use localhost
const API_BASE_URL = process.env.REACT_APP_API_URL || 
  (process.env.NODE_ENV === 'production' 
    ? '' // Relative URLs in production (proxied by Caddy)
    : 'http://127.0.0.1:8000'); // Localhost for development

// Helper function to handle API responses
const handleResponse = async (response) => {
  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.detail || `HTTP error! status: ${response.status}`);
  }
  return response.json();
};

// Public API for associations
export const publicAPI = {
  // Get all active associations
  getAssociations: async () => {
    const response = await fetch(`${API_BASE_URL}/api/associations`);
    return handleResponse(response);
  },

  // Get services for a specific association
  getAssociationServices: async (associationId) => {
    const response = await fetch(`${API_BASE_URL}/api/associations/${associationId}/services`);
    return handleResponse(response);
  },

  // Create a new reservation
  createReservation: async (reservationData) => {
    const response = await fetch(`${API_BASE_URL}/api/reservations`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(reservationData),
    });
    return handleResponse(response);
  },

  // Update person data for a reservation
  updatePersonData: async (reservationId, personData) => {
    const response = await fetch(`${API_BASE_URL}/api/reservations/${reservationId}/person`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(personData),
    });
    return handleResponse(response);
  },

  // Get available services for a reservation
  getAvailableServices: async (reservationId) => {
    const response = await fetch(`${API_BASE_URL}/api/reservations/${reservationId}/services`);
    return handleResponse(response);
  },

  // Select a service for a reservation
  selectService: async (reservationId, serviceId) => {
    const response = await fetch(`${API_BASE_URL}/api/reservations/${reservationId}/service/${serviceId}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
    });
    return handleResponse(response);
  },

  // Get available slots for a service
  getAvailableSlots: async (serviceId) => {
    const response = await fetch(`${API_BASE_URL}/api/services/${serviceId}/available`);
    return handleResponse(response);
  },

  // Reserve a specific slot
  reserveSlot: async (reservationId, slotId) => {
    const response = await fetch(`${API_BASE_URL}/api/reservations/${reservationId}/slots/${slotId}/reserve`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    });
    return handleResponse(response);
  },

  // Update reservation status to time selected
  updateReservationStatus: async (reservationId) => {
    const response = await fetch(`${API_BASE_URL}/api/reservations/${reservationId}/time-selected`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
    });
    return handleResponse(response);
  },

  // Get reservation details
  getReservation: async (reservationId) => {
    const response = await fetch(`${API_BASE_URL}/api/reservations/${reservationId}`);
    return handleResponse(response);
  },

  // Cancel a reservation
  cancelReservation: async (reservationId) => {
    const response = await fetch(`${API_BASE_URL}/api/reservations/${reservationId}`, {
      method: 'DELETE',
    });
    return handleResponse(response);
  },

  // Send confirmation email
  sendConfirmationEmail: async (reservationId) => {
    const response = await fetch(`${API_BASE_URL}/api/reservations/${reservationId}/send-confirmation`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    });
    return handleResponse(response);
  },

  cancelReservation: async (reservationId) => {
    const response = await fetch(`${API_BASE_URL}/api/reservations/${reservationId}/cancel`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    });
    return handleResponse(response);
  }
};
